const Products = [
    {
        id:1,
        name:"Bakso",
        description:"Digoreng bulat-bulat",
        originalPrice:15000,
        discountPercent:5,
        image:"Bakso.png",
        category:"Menu Utama",
    },
    {
        id:2,
        name:"Bolu Lapis",
        description:"Dilapisi dengan penuh kemanisan",
        originalPrice:35000,
        discountPercent:15,
        image:"Bolu Lapis.png",
        category:"Menu Penutup",
    },
    {
        id:3,
        name:"Bolu Susun",
        description:"Disusun dengan sangat menawan",
        originalPrice:40000,
        discountPercent:15,
        image:"Bolu Susun.png",
        category:"Menu Penutup",
    },
    {
        id:4,
        name:"Burger",
        description:"Sekali lahap terasa kejunya",
        originalPrice:30000,
        discountPercent:15,
        image:"Burger.png",
        category:"Menu Utama",
    },
    {
        id:5,
        name:"Donat",
        description:"Dibuat dengan penuh kenangan",
        originalPrice:90000,
        discountPercent:20,
        image:"Donat.png",
        category:"Menu Penutup",
    },
    {
        id:6,
        name:"Mata Sapi",
        description:"Jadi ingat pesan bunda",
        originalPrice:10000,
        discountPercent:0,
        image:"Mata Sapi.png",
        category:"Menu Pembuka",
    },
    {
        id:7,
        name:"Mie Aceh",
        description:"Terbuat dari rempah pilihan",
        originalPrice:25000,
        discountPercent:0,
        image:"Mie Aceh.png",
        category:"Menu Utama",
    },
    {
        id:8,
        name:"Pizza Hut",
        description:"Italia Punya",
        originalPrice:50000,
        discountPercent:15,
        image:"Pizza Hut.png",
        category:"Menu Utama",
    },
    {
        id:9,
        name:"Salad",
        description:"Yang ingin memulai vegan",
        originalPrice:35000,
        discountPercent:15,
        image:"Salad.png",
        category:"Menu Pembuka",
    },
];

export default Products;